import { Box, styled } from '@mui/material';

const StyledSessionCardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.surface.raised,
  border: `1px solid ${theme.palette.hairline.main}`,
  borderRadius: '14px',
  boxShadow: theme.palette.shadow.card,
  columnGap: theme.spacing(2),
  display: 'flex',
  padding: theme.spacing(2),
  position: 'relative',
  transition: 'transform 220ms cubic-bezier(0.32, 0.72, 0, 1), background-color 220ms cubic-bezier(0.32, 0.72, 0, 1)',
  '&:hover': {
    backgroundColor: theme.palette.surface.hover,
    transform: 'translateY(-2px)'
  }
}));

export default StyledSessionCardContainer;
